import { FileFormats } from '@common/Transpiler/types';
import { BackEndCodeLanguage } from '@prophecy/graphql-types/enums';
import { firstOfSet } from '@prophecy/utils/data';
import { usePersistentCallback } from '@prophecy/utils/react/hooks';
import { useMemo } from 'react';

import { useEnabledTranspilersAndLanguages } from '../../context/enabledTranspilers';
import { isInformatica } from './Import/utils';

export const useTranspilerEnabledLanguages = (
  source?: FileFormats,
  fallbackToAllSources?: boolean
): Set<BackEndCodeLanguage> => {
  const { transpilerToLanguageMap, supportedLanguages: traspilerAPIsupportedLanguages } =
    useEnabledTranspilersAndLanguages();

  return useMemo(() => {
    const enabledLanguages = traspilerAPIsupportedLanguages || new Set<BackEndCodeLanguage>();

    if (transpilerToLanguageMap) {
      if (source) {
        transpilerToLanguageMap[source]?.forEach((lang) => {
          enabledLanguages.add(lang);
        });
      } else if (fallbackToAllSources) {
        Object.keys(transpilerToLanguageMap).forEach((source) => {
          transpilerToLanguageMap[source as FileFormats]?.forEach((lang) => {
            enabledLanguages.add(lang);
          });
        });
      }
    }
    return enabledLanguages;
  }, [transpilerToLanguageMap, source, traspilerAPIsupportedLanguages, fallbackToAllSources]);
};

export const useTypeSpecificLanguage = function () {
  return usePersistentCallback(
    (transpilerType: FileFormats, supportedlanguages: Set<BackEndCodeLanguage>): BackEndCodeLanguage => {
      if (isInformatica(transpilerType)) {
        return supportedlanguages.has(BackEndCodeLanguage.sql)
          ? BackEndCodeLanguage.sql
          : (firstOfSet(supportedlanguages) as BackEndCodeLanguage);
      }
      if (transpilerType === FileFormats.alteryx) {
        return supportedlanguages.has(BackEndCodeLanguage.sql)
          ? BackEndCodeLanguage.sql
          : (firstOfSet(supportedlanguages) as BackEndCodeLanguage);
      }
      if (transpilerType === FileFormats.abinitio) {
        return supportedlanguages.has(BackEndCodeLanguage.scala)
          ? BackEndCodeLanguage.scala
          : (firstOfSet(supportedlanguages) as BackEndCodeLanguage);
      }
      return supportedlanguages.has(BackEndCodeLanguage.python)
        ? BackEndCodeLanguage.python
        : (firstOfSet(supportedlanguages) as BackEndCodeLanguage);
    }
  );
};
